import { render } from "./requestCreate.vue?vue&type=template&id=40117e1c&scoped=true"
import script from "./requestCreate.vue?vue&type=script&lang=js"
export * from "./requestCreate.vue?vue&type=script&lang=js"

import "./requestCreate.vue?vue&type=style&index=0&id=40117e1c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40117e1c"]])

export default __exports__